module.exports = __webpack_public_path__ + "static/media/mobile-ico.ff26da72.svg";